module.exports = __webpack_public_path__ + "img/header@2x.17c2a11.jpg";